<template>
    <div class="swiper-container quotes-carousel row-c-lg">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper quotes-carousel__slides-wrapper">
            <!-- Slides -->
            <div :key="index"
                 class="swiper-slide quotes-slide"
                 v-for="(slide, index) in slides"
                 v-html="slide">
            </div>
        </div>
        <div class="quotes-carousel__pagination"></div>
    </div>
</template>

<script>
    import Swiper from 'swiper/bundle';

    export default {
        props: {
            slides: {
                type: Array,
                default: []
            }
        },
        mounted() {
            const quotesCarousels = document.querySelectorAll('.quotes-carousel');
            for (let block of quotesCarousels) {
                const carPagination = block.getElementsByClassName('quotes-carousel__pagination')[0];
                new Swiper(block, {
                    spaceBetween: 30,
                    speed: 1000,
                    autoplay: {
                        delay: 7000,
                        disableOnInteraction: false,
                    },
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    pagination: {
                        el: carPagination,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '">0' + (index + 1) + '.</span>';
                        }
                    },
                });
            }
        }
    }
</script>